import {ColorFillPropertyType} from '@Components/color-fill';
import type {ColorStorage} from '@Components/color-picker-v2';
import {PosterEditorTestId} from '@/test-ids/poster-editor-test-id';

export const GRADIENT_STYLE_TYPES = [ColorFillPropertyType.LINEAR, ColorFillPropertyType.RADIAL];
export const GRADIENT_SWATCH_SIZE = 32;
export const GRADIENT_STYLE_TEST_IDS: Record<string, string> = {
  [ColorFillPropertyType.LINEAR]: PosterEditorTestId.GRADIENT_STYLE_LINEAR,
  [ColorFillPropertyType.RADIAL]: PosterEditorTestId.GRADIENT_STYLE_RADIAL,
};

export interface GradientStyleSectionProps {
  color: ColorStorage[];
  type: ColorFillPropertyType;
  selectedColorId: string;

  onChangeType(type: ColorFillPropertyType): void;

  onChangeSelectedColor(id: string): void;
}
